<template>
	<div class="main-contents">
		<div class="package">
			<div class="table">
				<!-- 프로젝트 지원IT프로 -->
				<div class="list-box">
					<fixTop :inContent="true" fixClass="top-fix">
						<template v-slot:conts>
							<div class="bt-list mt-10">
								<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1);">
							</div>
							
							<!-- 프로젝트 지원IT프로 리스트 -->
							<span v-if="prjList.length > 0">
								<div class="itv-result-box sp_human" v-for="(prjRow, prjIdx) in prjList" :key="prjIdx">
									<div class="prj_ct">
										<div class="mark-box">
											<div class="mark ep" v-if="prjRow.projectState == '2'">수행예정</div>
											<div class="mark cp" v-else-if="prjRow.projectState == '9'">완료</div>
											<div class="mark pf" v-else>수행중</div>

											<div v-if="prjRow.recrEndDateDiff >= 0  && prjRow.projectState != '9'" class="mark rc">모집중</div>
											<div class="mark cp" v-else>모집완료</div>
											<div class="regDate">등록일자<span style="margin-left: 10px;">{{prjRow.regYyyymmdd}}</span></div>
										</div>
										<div class="flex sp-tw">
											<div class="prj_outline">
												<div class="top">
													<div class="outline">
														<div class="value prj" @click="clickProjectInfo(prjRow.projectSeq, prjRow.projectState)">{{prjRow.projectNm}}</div>
													</div>
													<div class="outline">
														<div class="label">
															<p>개 요</p>
														</div>
														<div class="value text">{{prjRow.projectDtlDesc}}</div>
													</div>												
													<div class="outline">
														<div class="label">
															<p>고 객 사</p>
														</div>
														<div style="display: inline-flex; width: 750px;">
															<div class="prj_outline_clientname">
																{{prjRow.clientNm}}
															</div>
															<div class="prj_outline_clientloc">
																<img src="/images/location.png" alt="위치" />{{prjRow.projectLocCont}}
															</div>
														</div>
													</div>
													<div class="outline">
														<div class="label">
															<p>산 업 분 야</p>
														</div>
														<div class="value" style="display: inline-block !important;">
															<SelectComp type="text" cdId="PRO105" :value="prjRow.indtypeFilterCd"/> / <SelectComp type="text" cdId="PRO143" :value="prjRow.indtypeClassCd"/>
														</div>
													</div>
												</div>

												<div class="outline">
													<div class="label">
														<p>수 행 사</p>
													</div>
													<div class="value">{{prjRow.corpNm}}</div>
												</div>											
												<div class="outline">
													<div class="label">
														<p>개 발 기 간</p>
													</div>
													<div class="value">{{prjRow.projectStartEndYyyymmdd}}</div>
												</div>
												<div class="outline">
													<div class="label">
														<p>직 무 분 야</p>
													</div>
													<div class="value">
														<ul class="duty-list">
															<li v-for="(duty, index) in prjRow.dutyList" :key="index">
																<span>
																	<SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilterCd"/>/<SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyFieldCd"/>
																</span>
															</li>
														</ul>
													</div>
												</div>

												<div class="outline mb-0">
													<div class="label">
														<p>개 발 기 술</p>
													</div>
													<div class="value text">{{prjRow.devTechCont}}</div>
												</div> 											
												
											</div>

											<!--고객CI/지원자정보-->
											<div class="client_info">
												<!-- <div class="ci_box">
													<ImageComp type="image" :src="'/api/prj/tec/projectCorpImg?projectSeq='+imgSeq" defaultSrc="COMPANY" alt="고객사 로고"/>
												</div> -->
												<div class="deadline flex-col">
													<div>
														<span class="date" v-if="prjRow.recrEndDateDiff >= 0">
															<img class="period" src="/images/tec/prj/date_color.png" alt="마감기간"/> 마감 <span class="period">{{prjRow.recrEndDateDiff}}일</span> 전
														</span>
													</div>
													<div>
														<span>
															<img class="member" src="/images/tec/prj/member_sm.png" alt="지원자수"/> 
															지원 IT프로 <span calss="member">{{prjRow.appCount}}</span>명
														</span>
													</div>													
												</div>
											</div>
										</div>										
									</div>

									<div v-if="prjRow.appCount > 0"  style="padding: 20px;">
										<div class="filter itv">
											<div class="filter_box int">
												<ul>
													<li><img :class="prjRow.ordColDiv == '1' || !prjRow.ordColDiv ? 'filter' : ''" src="/images/icon_filter.png" alt="필터" /><p @click="getMberList(prjRow.projectSeq, prjIdx, '1');">평가등급 높은 순</p><span>ㅣ</span></li>
													<li><img :class="prjRow.ordColDiv == '2' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터" /><p @click="getMberList(prjRow.projectSeq, prjIdx, '2');">평가등급 낮은 순</p><span>ㅣ</span></li>
													<li><img :class="prjRow.ordColDiv == '3' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터" /><p @click="getMberList(prjRow.projectSeq, prjIdx, '3');">기술등급 높은 순</p><span>ㅣ</span></li>
													<li><img :class="prjRow.ordColDiv == '4' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터" /><p @click="getMberList(prjRow.projectSeq, prjIdx, '4');">기술등급 낮은 순</p></li>
												</ul>
											</div>
										</div>
										<div class="Board type3 sp_human">
											<table class="Board_type3 human itv">
												<colgroup>
													<col width="3%">
													<col width="10%">
													<col width="10%">
													<col width="7%">
													<col width="16%">
													<col width="8%">
													<col width="15%">
													<col width="12%">
													<col width="*">
												</colgroup>
												<thead>
													<tr>
														<th>NO</th>
														<th>지원분야</th>
														<th>인터뷰 요청</th>
														<th>평가등급</th>
														<th>IT프로명</th>
														<th>기술등급</th>
														<th>경력</th>
														<th>학력-졸업</th>
														<th>직무</th>
													</tr>
												</thead>
												<tbody>
													<tr :class="tecMberSeq == mberRow.mberSeq && selectedPrjIdx == prjIdx ? 'click' : ''" v-for="(mberRow, mberIdx) in prjRow.mberList" :key="mberIdx" @click="profileOpen(mberRow, prjIdx)">
														<td class="score">{{(pageInfo.pageUnit * (pageInfo.pageIndex-1)) + mberIdx+ 1 }}</td>
														<td class="field" :title="mberRow.workCont"><div>{{mberRow.workCont}}</div></td>
														<td class="score"><img class="itv_img" src="/images/mic_interview.png" alt="인터뷰" v-if="mberRow.statusImg != '07'"/></td>
														<td class="score">
															<grade-img type="TOT_SM_EVAL" :grade="mberRow.totEvalGradeCd" :specialYn="mberRow.specialGradeYn">
																<template v-slot:smark><div class="s-mark"><img src="/images/admin/s-mark.png" alt="스페셜마크"></div></template>
															</grade-img>
														</td>
														<td class="score">{{mberRow.mberNm}} ({{mberRow.gender | gender }})</td>
														<td class="score"><SelectComp type="text" :value="mberRow.techGradeCd" cdId="PRO106"/></td>
														<td class="score">{{mberRow.totWorkMonthCnt | months}}</td>
														<td class="score"><SelectComp type="text" :value="mberRow.schoolDivCd" cdId="PRO121"/></td>
														<td class="score">
														<span class="duty" v-if="mberRow.dutyCdList != undefined"><SelectComp type="text_comma_split_space" cdId="PRO142" :value="mberRow.dutyCdList"/></span>
														<span class="duty" v-else>-</span>
														</td>
													</tr>
												</tbody>
											</table>
											<pagingComp :pageInfo="pageInfo" @page-click="goPage" :classNm="'mb-0'"/>
										</div>
									</div>

									<!-- 지원인원이 없을 경우 -->
									<div v-else class="project_box tech-intv-none">
										<div>
											프로젝트 지원IT프로가 없습니다.
										</div>
									</div>

								</div>
							</span>
						</template>
						
					</fixTop>
				</div>

				<!-- 상세보기 -->
				<!-- <tec-profile :tecMberSeq="tecMberSeq" v-model="detailObj" @profileClose="profileClose()"/> -->
			</div>
		</div>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';
import gradeImg from "@/components/highpro/GradeImg.vue"
// import tecProfile from "@/components/highpro/TecProfile.vue";
import fixTop from "@/components/FixTop.vue";

export default {
	data() {
		return {
			corpdiv : this.$store.state.userInfo.mberDivCd,

			srcFilter : {
				// srcTxt : '',
				pageIndex : 1,
				ordCol : 'eval',
				sort : 'high',
			},
			// bottomNone : 'mb-0',
			tecMberSeq : '',
			// mberInfoYn : '',
			detailObj : {},
			prjList :[],
			pageInfo : {},

			selectedPrjIdx : 0,
			selectedOrdCol : '1',

			imgSeq : '',

			nowYyyymmdd : new Date().format("yyyyMMdd"),
		}
	},

	components : {
		pagingComp, gradeImg, fixTop
	},

	beforeMount() {
		// console.log('this param', this.$route.params.srchName);
		// if(this.$route.params.srchName != '') {
		// 	this.srcFilter.srcTxt = this.$route.params.srchName;
		// }
		
	},

	mounted(){
        // this.$emit('setViewConfig', {'footer': 'left', 'quickMenu':false})
		this.getDcoPgmPrjAppPrjList();
    },
    destroyed(){
        this.$emit('clearViewConfig')
    },

	methods : {
		getDcoPgmPrjAppPrjList() {
			var param = this.srcFilter;
			param.pageUnit = 15;
			param.pageSize = 10;
			param.projectSeq = this.$route.params.projectSeq;

			if(this.$store.state.userInfo.mberDivCd == '31') {
				param.prjListInqCond = 6;
			}

			// if(div) {
			// 	param.pageIndex = div;
			// 	param.ordCol = 'eval';
			// 	param.sort = 'high';
			// }
			// this.$.httpPost('/api/prj/dco/pmg/getDcoPgmPrjAppPrjList', param)
			this.$.httpPost('/api/prj/modul/getProjectList', param)
				.then((res) => {
					// console.log(res.data);					
					this.prjList = res.data.projectList;
					// this.pageInfo = res.data.pageInfo;

					for(var i in this.prjList){
						
						if(this.prjList[i].dutyFieldCont){
							var tempArr = this.prjList[i].dutyFieldCont.split(',');
							this.prjList[i].dutyList = [];

							for(var j in tempArr){
								this.prjList[i].dutyList.push({dutyFilterCd : tempArr[j].substr(0,2),
																   dutyFieldCd  : tempArr[j]});
							}
						}
					}
					this.getMberList(this.prjList[0].projectSeq, 0, '1');
				});
		},

		getMberList(seq, idx, div) {
			this.prjList[idx].ordColDiv = div;
			this.ordColDiv = div;
			
			this.ordCol = 'eval';
			this.sort = 'high';
			if('3, 4'.indexOf(div) > -1) this.ordCol = 'tech';
			if('2, 4'.indexOf(div) > -1) this.sort = 'low';
			
			var param = {};
			param.projectSeq = seq;
			param.ordCol = this.ordCol;
			param.sort = this.sort;
			param.corpdiv = this.corpdiv;

			// param.projectDivCd = this.prjList[0].projectDisplayDiv;

			// 지원 페이지에서 넘어올 때
			param.projectAppYn = 'Y'
			
			param.pageIndex = 1;
			param.pageUnit = 15;

			// this.$.httpPost('/api/prj/dco/pmg/getDcoPgmPrjAppMberList', param)
			this.$.httpPost('/api/prj/modul/getProjectTecMberList', param)
				.then((res) => {
					this.prjList[idx].mberList =  res.data.tecMberList;
					this.pageInfo = res.data.pageInfo;
					this.imgSeq = this.prjList[idx].projectSeq;
				});
		},

		// 페이지 이동
		goPage(page) {
			this.srcFilter.pageIndex = page;
			this.getDcoPgmPrjAppPrjList();
		},

		// 프로젝트 상세보기 팝업
		clickProjectInfo(projectSeq, projectRecrStatus) {
			var param = {
				projectSeq : projectSeq,
				projectRecrStatus : projectRecrStatus
			};
			this.$.popup('/dco/pmg/prj/PRJ305P01', param, {width:0, height:0})
				// .then(res => {})
				// .catch(err => {})
				;
		},

		// IT프로 상세 열기prjIdx
		profileOpen(mberRow, prjIdx){
			if(this.corpdiv == '31' && mberRow.mberInfoYn == 'N'){ // 파트너사 > IT프로의 소속사가 변경된 경우 상세정보 조회불가
				this.profileClose();
				alert("소속이 변경된 IT프로입니다.");
			}else{
				// this.tecMberSeq = mberRow.mberSeq; 
				this.selectedPrjIdx = prjIdx;
				if(this.corpdiv == '31') {
					this.$router.push({name : 'SRH401M02', params : { tecMberSeq : mberRow.mberSeq }});
				} else {
					this.$router.push({name : 'SRH301M02', params : { tecMberSeq : mberRow.mberSeq }});
				}
			}
		},

		// IT프로 상세 닫기
		profileClose() {
			this.tecMberSeq = '';
			this.detailObj = {};
		},

	}	

}
</script>